angular.module('SpidApp')

.factory('CsvConverter', ['gettextCatalog', function (gettextCatalog) {
    var CsvConverter = {
        /**
            @params:
                - a 2D array like this: [ ['marcel', 35], ['joey', 25]]
                - the array of string representing the keys to call on each object in the right order
                - the string on which to join the columns (default to ',')
                - the string on which to join the lines (default to '\n')
            @returns the csv representation
        **/
        arrayToCsv: function (array, fields, options) {
            options = options || {}

            var columnGlue = options.columnGlue || ';'
            var lineGlue = options.lineGlue || '\r\n'
            var hasHeaders = options.hasHeaders || false

            if (!array || !fields || !columnGlue || !lineGlue) {
                throw 'CsvConverter::arrayToCsv() - Missing parameters'
            }

            var fieldsTranslate = _.map(fields, function (field) {
                return gettextCatalog.getString(field);
            })

            var csvField = ''
            if (hasHeaders) {
                csvField = '"' + fieldsTranslate.join('"' + columnGlue + '"') + '"' + lineGlue
            }

            var csvData = array.map(function (e) {
                var fieldValues = fields.map(function (f) {
                    return (e[f] + '').replace(/"/g, '\\"')
                })

                return '"' + fieldValues.join('"' + columnGlue + '"') + '"'
            }).join(lineGlue)

            return csvField + csvData
        }
    }

    return CsvConverter
}])